import { useState } from 'react';
import axios from 'axios';
import './Newsletter.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
      console.error('Newsletter error:', error);
    }
  };

  return (
    <section className="newsletter-section" data-testid="newsletter-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="newsletter-card">
          <h3 className="newsletter-title">Stay Updated</h3>
          <p className="newsletter-text">
            Get business insights, tips, and updates delivered to your inbox monthly.
          </p>

          {status === 'success' && (
            <div className="newsletter-success" data-testid="newsletter-success">
              ✓ Thanks for subscribing! Check your inbox for confirmation.
            </div>
          )}

          {status === 'error' && (
            <div className="newsletter-error" data-testid="newsletter-error">
              ✗ Something went wrong. Please try again.
            </div>
          )}

          <form onSubmit={handleSubmit} className="newsletter-form" data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
              data-testid="newsletter-email"
            />
            <button type="submit" className="newsletter-button" data-testid="newsletter-submit">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;